import { requestSubscription, graphql } from "react-relay";
import { ConnectionHandler } from "relay-runtime";
import moment from "moment";
import environment from "../Network";

const subscription = graphql`
  subscription ReportSubscription {
    reportSubscription {
      action
      reportId
      report {
        id
        pk
        createdAt
        afterWork
        project {
          pk
          name
          color
        }
        milestone {
          pk
        }
        reportType {
          pk
          labelDisplay
          color
        }
        numberOfMinutes
        note
        taskId
        projectEmployee {
          pk
          id
          user {
            id
          }
        }
      }
      projectEmployeesTimeSpent {
        edges {
          node {
            id
            pk
            project {
              name
              id
              pk
              color
            }
            monthlyTimeSpent
          }
        }
      }
    }
  }
`;

export default (variables) => {
  return requestSubscription(
    environment, // see Environment docs
    {
      subscription,
      variables: variables ? variables : {},
      updater: (store) => {
        // Get the notification
        const rootField = store.getRootField("reportSubscription");
        const report = rootField.getLinkedRecord("report");
        const action = rootField.getValue("action");
        // Add it to a connection
        let viewer = store.getRoot().getLinkedRecord("user");
        const user_id = viewer.getValue("id");
        const user_report_id = report
          .getLinkedRecord("projectEmployee")
          .getLinkedRecord("user")
          .getValue("id");
        if (user_id === user_report_id) {
          const createdAt = moment(report.getValue("createdAt")).format(
            "DD/MM/YYYY"
          );
          const today = moment().format("DD/MM/YYYY");
          viewer.setLinkedRecord(
            rootField.getLinkedRecord("projectEmployeesTimeSpent"),
            "projectEmployeesTimeSpent"
          );
          if (action === "create") {
            if (today === createdAt) {
              let connection = ConnectionHandler.getConnection(
                viewer,
                "CompletedTasks_reports"
              );
              let reportEdge = ConnectionHandler.createEdge(
                store,
                connection,
                report,
                "ReportType"
              );
              ConnectionHandler.insertEdgeBefore(connection, reportEdge);
              connection = ConnectionHandler.getConnection(
                viewer,
                "Clock_reports"
              );
              reportEdge = ConnectionHandler.createEdge(
                store,
                connection,
                report,
                "ReportType"
              );
              ConnectionHandler.insertEdgeBefore(connection, reportEdge);
            } else {
              let connection = ConnectionHandler.getConnection(
                viewer,
                "FinishWorkModal_reportsOffset"
              );
              let reportEdge = ConnectionHandler.createEdge(
                store,
                connection,
                report,
                "ReportType"
              );
              ConnectionHandler.insertEdgeBefore(connection, reportEdge);
              // update graph
              const projectEmployeeId = report
                .getLinkedRecord("projectEmployee")
                .getValue("id");
              const projectEmployee = store.get(projectEmployeeId);
              projectEmployee.setValue(
                projectEmployee.getValue("monthlyTimeSpent") +
                  report.getValue("numberOfMinutes"),
                "monthlyTimeSpent"
              );
            }
          } else if (action === "delete") {
            let reportId = rootField.getValue("reportId");

            let connection = ConnectionHandler.getConnection(
              viewer,
              "CompletedTasks_reports"
            );
            ConnectionHandler.deleteNode(connection, reportId);
            connection = ConnectionHandler.getConnection(
              viewer,
              "FinishWorkModal_reportsOffset"
            );
            ConnectionHandler.deleteNode(connection, reportId);
            connection = ConnectionHandler.getConnection(
              viewer,
              "Clock_reports"
            );
            ConnectionHandler.deleteNode(connection, reportId);
            const userReport = store.getRoot().getLinkedRecord("userReport");
            if (userReport) {
              connection = ConnectionHandler.getConnection(
                userReport,
                "CompletedTasks_reports"
              );
              ConnectionHandler.deleteNode(connection, reportId);
            }
            connection = ConnectionHandler.getConnection(
              viewer,
              "ModalTasksButton_reportsOld"
            );
            ConnectionHandler.deleteNode(connection, reportId);
          } else if (action === "update") {
            const reportId = report.getValue("id");
            const oldReport = store.get(reportId);
            oldReport.setValue(report.getValue("note"), "note");
            let newField = report.getLinkedRecord("project");
            if (newField)
              oldReport.setLinkedRecord(
                report.getLinkedRecord("project"),
                "project"
              );
            else oldReport.setValue(null, "project");
            newField = report.getLinkedRecord("milestone");
            if (newField)
              oldReport.setLinkedRecord(
                report.getLinkedRecord("milestone"),
                "milestone"
              );
            else oldReport.setValue(null, "milestone");
            newField = report.getLinkedRecord("reportType");
            if (newField)
              oldReport.setLinkedRecord(
                report.getLinkedRecord("reportType"),
                "reportType"
              );
            else oldReport.setValue(null, "reportType");
            oldReport.setValue(report.getValue("taskId"), "taskId");
            oldReport.setValue(
              report.getValue("numberOfMinutes"),
              "numberOfMinutes"
            );
          }
        }
      },
      // optional but recommended:
      onCompleted: () => {
        /* server closed the subscription */
      },
      onError: (error) => console.error(error),
    }
  );
};



// WEBPACK FOOTER //
// ./src/subscriptions/ReportSubscription.js